import React, { useEffect } from 'react';

import Stack from '@mui/material/Stack';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import useStyles from './styles';
import { SidebarItemType } from 'src/interfaces/idashboard';
import { SidebarOptionType } from 'src/interfaces/iproptypes';
import { sampleMarket, sidebarClosedWidth, sidebarWidth } from 'src/utils/const';
import { useSelector } from 'react-redux';
import postOnSlack from 'src/core/postOnSlack';
import { COLOR_PRIMARY_2, DEFAULT_TEXT_COLOR } from 'src/utils/colors';
import { useHistory } from 'react-router-dom';

const SidebarOption = ({
  item,
  isSubGroup,
  handleSidebarClick,
  handleSidebarListItemClick,
  matches,
  sidebarOpen,
  setSidebarOpen,
  index,
  selectedSidebarIndex,
  isExpanded,
  setIsExpanded,
  user,
  setOpenReportComparePage,
}: SidebarOptionType) => {
  const classes = useStyles();
  const pathname = window.location.pathname;
  const estimatorSearchAddress = useSelector(
    state => (state as any).dashboard.estimatorSearchMarket
  );

  const history = useHistory();

  useEffect(() => {
    if (sidebarOpen === false) {
      setIsExpanded && setIsExpanded(false);
    } else {
      item.name === 'Calculator' && setIsExpanded && setIsExpanded(false);
    }

    if (
      pathname === '/airbnb-calculator' ||
      pathname === '/airbnb-calculator/' ||
      pathname === '/my-analysis' ||
      pathname === '/my-analysis/'
    ) {
      setIsExpanded && setIsExpanded(true);
    }
  }, [sidebarOpen, pathname, estimatorSearchAddress]);

  const sendSlackNotification = clickedItem => {
    postOnSlack(
      'C05JDGPMH8T',
      `User: ${user.email} clicked on ${clickedItem} Button In the App SideBar`
    );
  };

  return (
    <ListItem
      button
      classes={{ root: classes.sideBar }}
      onClick={() => {
        if (item.name === 'Custom Data' || item.name === 'API') {
          sendSlackNotification(item.name);
        }

        setOpenReportComparePage && setOpenReportComparePage(false);

        if (item.name === 'Calculator') {
          history.push('/airbnb-calculator');
        }

        if (item.redirectionLink) {
          window.open(item.redirectionLink);
          return;
        }

        if (item.stateName) {
          handleSidebarClick && handleSidebarClick(item.stateName);
          handleSidebarListItemClick(item.listIndex);
          if (matches) {
            setSidebarOpen(false);
          }
        }

        if (
          (window.location.pathname == '/airbnb-data' ||
            window.location.pathname == '/airbnb-data/' ||
            window.location.pathname == '/') &&
          item.listIndex === 4
        ) {
          window.open(`/airbnb-data/united-kingdom/0/${sampleMarket}?guests=true`, '_self');
        } else {
          if (isExpanded) {
            setIsExpanded && setIsExpanded(false);
          } else {
            setIsExpanded && setIsExpanded(true);
          }
        }
      }}
      style={{
        marginLeft: isSubGroup ? '10px' : 0,
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      <ListItemIcon
        style={{
          minWidth: 0,
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {item.isPage && (
          <>
            <div
              style={{
                borderWidth: '0px 0px 0px 1px',
                borderStyle: 'solid',
                // borderColor: '#ffffff44',
                borderColor: `${DEFAULT_TEXT_COLOR}88`,
                marginLeft: '12px',
                height: index === 0 ? '20px' : index === 1 ? '56px' : '60px',
                marginRight: '10px',
                marginTop: index === 0 ? '0px' : index === 1 ? '-32px' : '-28px',
              }}
            />
          </>
        )}

        <Stack
          direction={matches ? 'row' : 'column'}
          justifyContent={'center'}
          alignItems="center"
          spacing={0}
          sx={{
            background:
              item.listIndex === selectedSidebarIndex ? COLOR_PRIMARY_2 + '11' : 'transparent',
            padding: '5px 4px',
            borderRadius: '12px',
            maxWidth: matches ? sidebarWidth : sidebarClosedWidth,
            width: '100%',
            margin: matches ? undefined : 'auto',
          }}
        >
          {(item as SidebarItemType)?.icon &&
            React.cloneElement((item as SidebarItemType).icon, {
              style: {
                ...(item.listIndex === selectedSidebarIndex
                  ? { color: COLOR_PRIMARY_2 }
                  : { color: '#000' }),
                ...(matches ? {} : { marginBottom: '4px' }),
              },
            })}

          {/* {sidebarOpen && ( */}
          <>
            <ListItemText
              id={item.listIndex == 11 ? 'searchTab' : ''}
              classes={{
                primary:
                  item.listIndex === selectedSidebarIndex
                    ? classes.sidebarTextSelected
                    : classes.sidebarText,
              }}
              primary={item.name}
              style={{ maxWidth: sidebarClosedWidth, textAlign: matches ? 'left' : 'center' }}
            />
            {/* {item?.chipLabel && <div className={classes.betaButton}>{item.chipLabel}</div>} */}
            {item.isBeta && <div className={classes.betaButton}>Beta</div>}
          </>
          {/* )}  */}

          {!item.isPage &&
            item.children?.length > 0 &&
            sidebarOpen &&
            (isExpanded ? (
              <KeyboardArrowDownRoundedIcon
                sx={{
                  float: 'right',
                  color: DEFAULT_TEXT_COLOR,
                }}
              />
            ) : (
              <ChevronRightRoundedIcon
                sx={{
                  float: 'right',
                  color: DEFAULT_TEXT_COLOR,
                }}
              />
            ))}
        </Stack>
      </ListItemIcon>
    </ListItem>
  );
};

export default SidebarOption;
